import { Typography } from '@mui/material'
// import { InlineWidget } from 'react-calendly'
import { MotionViewport, varFade, varSlide } from "../../../components/minimal/animate/index.jsx";
import { Stack } from '@mui/material'
import { m } from 'framer-motion'

const BookDemo = () => {
    return (
        <div id="book-a-demo" >
            <MotionViewport>
                <Stack sx={{ textAlign: 'center', mt: 16 }}>
                    <m.div variants={varFade().inUp}>
                        <Typography variant="h2">
                            קבעו פגישת דמו עכשיו
                        </Typography>
                    </m.div>
                </Stack>
            </MotionViewport>
            {/* <InlineWidget pageSettings={{
            primaryColor: '#7635dc',
        }} styles={{ overflow: 'hidden', height: '700px' }} url="https://calendly.com/dan-nimi/30min?primary_color=7635dc" /> */}
            <div id="schedule_form">
                <iframe src="https://calendly.com/dan-nimi/30min?primary_color=7635dc" width="100%" height="700" style={{ overflow: 'hidden' }} frameborder="0"></iframe>
            </div>
        </div>
    )
}

export default BookDemo